import { MutableRefObject } from 'react';

export const findParentByClass = (
  element: HTMLElement,
  parentClass: string,
  deep = 10,
) => {
  let parent: HTMLElement | null = element.parentElement;
  for (let i = 0; i < deep; i++) {
    if (!parent) {
      break;
    }
    if (parent.className.includes(parentClass)) {
      return parent;
    }
    parent = parent.parentElement;
  }
};

export const clearClassList = (element: HTMLElement) => {
  const { classList } = element;
  while (classList.length > 0) {
    classList.remove(classList.item(0)!);
  }
};

export function onComponentRef({
  componentRef,
  parentCssClass,
  ref,
}: {
  componentRef: MutableRefObject<HTMLElement | undefined>;
  parentCssClass: string;
  ref: HTMLElement | null;
}) {
  if (ref) {
    const parentElement = findParentByClass(ref, parentCssClass);
    if (parentElement) {
      if (ref.className) {
        parentElement.parentElement?.classList.add(...ref.className.split(' '));
        clearClassList(ref);
      }
      componentRef.current = parentElement;
    }
  }
}
